// PRODUCTION
export const ENV_TYPE = 'production';
// export const API_URL = 'https://getbevvi.com:4000/api/';
export const API_URL = "https://api.getbevvi.com/api/";
export const STRIPE_URL = "https://connect.getbevvi.com/";
// export const STRIPE_URL = 'https://getbevvi.com:3038/';

export const GOOGLE_ANALYTIC_ID: string = 'UA-126994279-2';
export const EYE_KANDY_ID = 'bc2b187b-04f0-4edf-bab8-671e93817855';
export const GOOGLE_ANALYTIC_GA4_ID: string = 'G-8SEFMKMX59';
export const APP_VERSION = 'v2.0.0';
export const GOOGLE_API_KEY = 'AIzaSyCan8ZZ_sPTK2q9rgVW9wrVnHY0zQXKW-o';
export const FACEBOOK_API_URL = 'https://graph.facebook.com/v5.0/';
export const WEB_LINK = 'https://corporate.getbevvi.com/';
// export const IMAGES_URL = 'https://getbevvi.com:4000/api/storages/bevvi/download/';
export const IMAGES_URL = 'https://api.getbevvi.com/api/storages/bevvi/download/';
export const AWS_IMAGE_URL = 'https://bevvi.s3.us-east-2.amazonaws.com/';
export const MILES_TO_RADIAN = 3963.2;
export const USER_MILES = 5;
export const SECRETKEY = 'JPpOD5at3h';
export const BUCKET_NAME = 'bevvi';
export const FACEBOOK_APP_ID = '507729772953443'; // For Production
export const BRANCH_LINK = 'https://bevvi.app.link/getbevvi';
export const PRODUCT_URL = 'https://corporate.getbevvi.com/productdetail/';
export const PRODUCTLISTING_URL = 'https://corporate.getbevvi.com/productlisting/';
export const CHECKOUT_URL: string = 'https://corporate.getbevvi.com/recipient/';
export const REMARKETY_STOREID = '845eWQ4q';
export const KLAVIYO_PUBLIC_KEY: string = 'Un2ZJj';
export const STRIPE_PUBLISH_KEY = 'pk_live_tGJijuibdYFvgjwHR8ObIpem';
export const TIP_AMOUNT = 0.05;
export const PROMO_CODE = 'GETNOW10';
export const DISCOUNT_MSG = 'Click on apply & get $10 discount on orders above $50.';
export const IOS_APP_LINK: string = 'https://itunes.apple.com/us/app/itunes-connect/id1530794572'


// Title
export const MAIN_TITLE: string = 'Bevvi makes corporate gifting of alcohol seamless';
export const PRODUCTLISTING_TITLE: string = '| Bevvi makes corporate gifting of alcohol seamless';
export const CART_TITLE: string = 'Finalize Order - Cart | Bevvi';
export const PLACEORDER_TITLE: string = 'Finalize Order - Placeorder | Bevvi';
export const CHECKOUT_TITLE: string = 'Thanks for Order - Checkout | Bevvi';
export const LOGIN_TITLE: string = 'Login for Corporate Alcohol Gifting | Bevvi';

// Description
export const DESCRIPTION: string = 'Bevvi makes corporate gifting of alcohol seamless . Send your favorite drinks to your team or clients, no minimum!!!!!';

// retailbevvi

export const RETAIL_LINK: string = 'https://retail.getbevvi.com';
